<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{ element_group && element_group.data.attributes.name }}</h1>
    </div>
    <div class="content">
      <div class="wrapper-x-40">
        <AdminTypesForm :type="type" />
      </div>
    </div>
  </div>
</template>

<script>
import AdminTypesForm from "../../../components/Admin/Types/Form";

export default {
  name: "TypesForm",
  components: { AdminTypesForm },
  async created() {
    await this.loadLandscapingTypesContext();
  },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    element_group() {
      return this.$store.state.elements.element_group;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
    type() {
      const typeFromShow = this.$store.state.types.type;
      if (typeFromShow && typeFromShow.data) return typeFromShow;
      return this.$store.state.types.edit;
    },
  },
  methods: {
    async loadLandscapingTypesContext() {
      if (!this.slug) return;

      const elementGroup = await this.$store.dispatch(
        "elements/fetchElementGroup",
        this.slug
      );

      await this.$store.dispatch("types/setCurrentModelAndGroupId", {
        currentModel: "App\\Models\\Element",
        currentGroupId: elementGroup?.data?.element_group_id ?? null,
      });

      this.$store.dispatch("types/setAdd", false);
      this.$store.dispatch("types/setEdit", null);
      this.$store.commit("types/FETCH_TYPE", {});

      if (this.$route.name === "edit_landscaping_type" && this.$route.params.type_id) {
        await this.$store.dispatch("types/fetchType", this.$route.params.type_id);
      }
    },
  },
};
</script>
